import { FSA } from '../../shared/types'
import { CallStatus } from '../dashboard/calls.types'
import { NOTIFY_AUTOMATED_ACTION } from './tagging.actions'

export interface TaggingState {
  [callIdentifier: string]: CallStatus
}

export const initialState: TaggingState = {}

export function reducer(
  state: TaggingState | undefined = initialState,
  action: FSA
): TaggingState {
  switch (action.type) {
    case NOTIFY_AUTOMATED_ACTION:
      if (action.meta) {
        return {
          ...state,
          [action.meta.callIdentifier]: action.meta.callStatus,
        }
      }
      return state
    default:
      return state
  }
}
